import { render } from "./IconControl.vue?vue&type=template&id=7a053d9c"
import script from "./IconControl.vue?vue&type=script&lang=js"
export * from "./IconControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__